import { FC } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { Row, Col } from 'react-bootstrap';
import styled from 'styled-components';
import { Field, ControlSelect } from '../../../common/components/Form';
import { PrimaryButton } from '../../../common';
import { Spacing } from '../../../assets/GlobalStyle/Variables';
import { ReportFilterItem } from '../useStatistics';

type ReportFilterFormData = {
  [key: string]: string | number | null;
};

type ReportFilterProps = {
  filters: ReportFilterItem[];
  onSubmit: (data: any) => void;
};

export const ReportFilter: FC<ReportFilterProps> = ({ filters, onSubmit }) => {
  const defaultValues = Object.fromEntries(
    filters.map(f => [f.key, f.defaultValue || null])
  );

  const methods = useForm<ReportFilterFormData>(
    { defaultValues }
  );

  const handleSubmit = (data: ReportFilterFormData) => {
    onSubmit(data);
  };

  return (
    <FormProvider {...methods}>
      <ReportFilterForm onSubmit={methods.handleSubmit(handleSubmit)}>
        <Row>
          {filters.map((filter, idx) => (
            <>
              <Col md={4} key={filter.key}>
                {filter.type === 'select' && filter.options && (
                  <ControlSelect
                    id={filter.key}
                    name={filter.key}
                    options={filter.options}
                    { ...filter }
                  />
                )}
                {filter.type !== 'select' && (
                  <Field
                    id={filter.key}
                    name={filter.key}
                    { ...filter}
                  />
                )}
              </Col>
              {(idx + 1) % 2 === 0 && (
                <Col md={4}></Col>
              )}
            </>
          ))}
        </Row>
        <Row>
          <Col md={12}>
            <StyledButtonWrapper>
              <PrimaryButton type="submit">Načíst</PrimaryButton>
            </StyledButtonWrapper>
          </Col>
        </Row>
      </ReportFilterForm>
    </FormProvider>
  );
};

const ReportFilterForm = styled.form`
  margin-bottom: ${Spacing(8)};
  margin-top: ${Spacing(8)};
`;

const StyledButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-top: ${Spacing(4)};
`;
